<template>
    <el-dialog
            class="selfModal"
            title="添加文件"
            :close-on-click-modal="false"
            :visible="show"
            width="700px"
            :modal="false"
            @close="show=false"
    >
        <div>
            <el-form :model="formValidate"
                             :rules="ruleValidate"
                             ref="formValidate" label-width="80px"
                             class="demo-ruleForm">
                <el-form-item label="名称" prop="title">
                    <el-input v-model="formValidate.title" size="mini" ></el-input>
                </el-form-item>
                <el-form-item label="公文内容" prop="content" style="width: 100%;">
                    <quillEditorCom v-model="formValidate.content"  />
                </el-form-item>
                <el-form-item label="可见角色" prop="roleIds">
                    <el-select size="mini" v-model="formValidate.roleIds" multiple placeholder="请选择角色" filterable clearable class="w100">
                        <el-option v-for="item in roleList"
                                   :key="item.roleId"
                                   :label="item.roleName"
                                   :value="item.roleId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文件分类" prop="fileType">
                    <el-select size="mini" v-model="formValidate.fileType" placeholder="请选文件分类" class="w100">
                        <el-option v-for="item in selectData"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门" prop="deptId">
                    <el-col :span="21">
                        <el-input disabled size="mini" v-model="formValidate.deptName"></el-input>
                    </el-col>
                    <el-col :span="2" style="float: right;">
                        <el-button @click="changeUserDept" icon="el-icon-menu"></el-button>
                    </el-col>
                </el-form-item>
                <el-form-item label="附件：" prop="fileIds">
                    <div >
                        <el-upload
                                class="upload-demo"
                                action="#"
                                :file-list="filelist"
                                accept=".txt,.png,.jpg,.bmp,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.7z,.rar"
                                :before-remove="beforeRemoveFn"
                                :before-upload="beforeUploadFn"
                        >
                            <el-button slot="trigger">
                                <i class="el-icon-upload"></i>
                            </el-button>

                        </el-upload>

                    </div>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="submitForm('formValidate')" :disabled="subDisabled">确 认</el-button>
             <el-button @click="show=false">关 闭</el-button>
        </span>
        <el-dialog
            class="deptDialog"
            :close-on-click-modal="false"
            :visible.sync="chooseDepartment.state"
            width="480px"
            title="部门选择"
            :modal="false"
        >
            <div class="modaltree">
                <treeMenu
                    ref="treeMenu"
                    initId="0"
                    :showArrow="false"
                    :showShadow="false"
                    :isEdit="false"
                    loadStyle="staticLoad"
                    @nodeClick="nodeIdModal"
                    :showBox="false"
                ></treeMenu>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="depTreeBtn('1')">确 定</el-button>
            </span>
        </el-dialog>

    </el-dialog>
</template>

<script>
    import {NeizhenUtil} from "@/util/datarouters";
    import { tabsList, tHallPolicyFileSave ,tHallPolicyFileUpdate} from '@/api/portrayal/policy'
    import {getList} from '@/api/system/role'
    import {sysFileUpload,sysFileDelete} from '@/api/managementCenter/otherApi'
    import '@/util/jquery-2.2.4.min.js'
    import quillEditorCom from '@/components/common/quillEditor.vue'
    import treeMenu from '@/components/treeMenu/index.vue'

    export default {
        name:'addFilePollicy',
        props: {
            addData: {
                type: Object,
                required: true
            },
        },
        components: {quillEditorCom,treeMenu,},
        data() {
            return {
                chooseDepartment: {
                    state: false,
                    data: {},
                    showBox: false
                },
                subDisabled: false,
                show:false,
                type:'',
                data:null,
                filelist:[],
                formValidate: {
                    title: '',
                    fileType: '',
                    type: '1',
                    roleIds: [],
                    fileIds:[],
                    content: '',
                    deptId: '',
                    deptName: '',
                    id:''

                }, // 表单数据绑定
                ruleValidate: {
                    title: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    fileType: [
                        {required: true, message: '请选择文件分类', trigger: 'change'}
                    ],
                    type: [
                        {required: true, message: '请选择文件来源', trigger: 'change'}
                    ],
                    roleIds: [
                        {required: true, message: '权限不能为空', trigger: 'change'}
                    ],
                    content: [
                        {required: true, message: '内容不能为空', trigger: 'blur'}
                    ],
                    deptId: [
                        {required: true, message: '请选择部门', trigger: 'change'}
                    ],
                    fileIds: [
                        {required: true, message: '请上传文件', trigger: 'change'}
                    ],
                }, // 表单验证
                selectData: [],
                roleList: []
            };
        },
        computed: {
        },
        watch: {
            show(value){
                if(value){
                    this.getRoleList();
                    this.showAddData();
                }else{
                         this.filelist=[];
                        this.formValidate= {
                        title: '',
                            fileType: '',
                            type: '1',
                            roleIds: [],
                            fileIds:[],
                            content: '',
                            deptId: '',
                            deptName: '',
                            id:''
                    };
                }

            }

        },
        methods: {
            // 显示弹框
            dialogShow (type,data) {
                // 重置表单、显示弹框
                this.show = true;
                this.type=type;
                this.data=data;
                if(type=='edit'){
                    this.formValidate.title= data.title
                    this.formValidate.id= data.id
                    this.formValidate.content= data.content
                    this.formValidate.deptId = data.deptId
                    this.formValidate.deptName = data.deptName
                    this.formValidate.fileType= data.fileType
                    this.formValidate.roleIds = data.fileRole.map((item) => Number(item.roleId));
                    this.filelist=(data.fileList||[]).map(item=>{
                        return {...item,name:item.fileName,id:item.fileId}
                    })
                }

            },
            beforeRemoveFn(file) {
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                    this.filelist =this.filelist.filter(i=>{
                        return file.id!=i.id
                    })
                })
            },
            deleteFile(id,callback){
                sysFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        callback&&callback()
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            // 上传文件之前的方法
            beforeUploadFn(file){

                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                    return isLt2M
                }
                let fd = new FormData();
                fd.append('fromTarget',0)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                sysFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$message.success(  "上传文件成功!" );
                        this.filelist.push(
                            {
                                ...data.data,
                                name:data.data.fileName

                            }
                        )
                    }else{
                        this.$message.warning( data.msg|| "上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },
            // 更换部门名称弹框
            changeUserDept() {
                this.chooseDepartment.data = {};
                this.chooseDepartment.chooseBox = false;
                this.chooseDepartment.state = true;
            },
            nodeIdModal(tree) {
                this.chooseDepartment.data = tree
            },
            // 新增-部门选择确认按钮
            depTreeBtn() {
                this.formValidate.deptId = this.chooseDepartment.data.id;
                this.formValidate.deptName = this.chooseDepartment.data.name;
                this.chooseDepartment.state = false
            },
            getRoleList(){
                getList()
                .then(({data}) => {
                    if(data.code == 0){
                        this.roleList = data.data;
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            },
            showAddData() {
                let url = null;
                url = '/admin/dict/type/policy_type'
                tabsList(url).then(res => {
                    if (res.data.code == 0) {
                        this.selectData = res.data.data || []
                    }
                })
            },
            submitForm(formNames) {
                this.formValidate.fileIds=this.filelist.map(i=>i.id);
                this.$refs[formNames].validate((valid) => {
                    if (valid) {
                        this.subDisabled=true;
                        let obj = {
                            fileType: String(this.formValidate.fileType),
                            fileRole: this.formValidate.roleIds.map((item) => {
                                return {roleId: String(item)}
                            }),
                            title: this.formValidate.title,
                            type: this.formValidate.type,
                            content: this.formValidate.content,
                            deptId: this.formValidate.deptId,
                            fileIds:this.formValidate.fileIds
                        }
                        if(this.type=='edit'){
                            obj.id=this.formValidate.id
                        }
                        let method=tHallPolicyFileSave;
                        if(this.type=='edit'){
                            method=tHallPolicyFileUpdate;
                        }
                        method(obj).then(({data}) => {
                                if(data.code == 0){
                                   this.$message.success(this.type=='edit'?'编辑成功':'新增成功');
                                   this.$emit('callBack')
                                    this.show= false
                                }else {
                                    this.$message.error(data.msg)
                                }
                            }).finally(() => {
                            this.subDisabled = false;
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .selfModal {
        box-sizing: content-box;
    }
    .content {
        overflow: hidden;
        overflow-y: auto;
        width: 100%;
        min-height: 50px;
        max-height: 100px;
        padding: 0 10px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, .3), 0 0 40px rgb(255, 255, 255) inset;
        border-radius: 3px;
        -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, .3), 0 0 40px rgb(255, 255, 255) inset;
        -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, .3), 0 0 40px rgb(255, 255, 255) inset;
        -o-box-shadow: 0 1px 6px rgba(0, 0, 0, .3), 0 0 40px rgb(255, 255, 255) inset;

        .docList {
            width: 100%;
            height: 35px;
            margin-top: 5px;
            background: #f6f9ff;
            border-radius: 3px;

            .listItem {
                float: left;
                display: inline-block;
                width: 10%;
                height: 35px;
                color: #94c6e7;
                font-size: 30px;
                line-height: 35px;
            }

            .listContent {
                float: left;
                overflow: hidden;
                width: 55%;
                height: 35px;
                margin-left: 5%;
                line-height: 35px;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .deleteIcon {
                float: right;
                width: 10%;
                height: 35px;
                margin-left: 5%;
                color: red;
                font-size: 15px;
                line-height: 35px;
                text-align: center;
            }

            .deleteIcon1 {
                float: left;
                width: 10%;
                height: 35px;
                margin-left: 5%;
                color: red;
                font-size: 15px;
                line-height: 35px;
                text-align: center;
            }
        }
    }
    .fileDiv{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .fileUp{
        padding-bottom:20px;
    }
    .ui-upload{
        height: 80px;
        width: 120px;
        font-size: 15px;
        line-height: 30px;
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        text-align: center;
        border-radius: 5px;
        justify-content: center;
        span:nth-of-type(2){
            width: 100%;
        }
        .tubiao{
            color: rgba(64, 158, 255, 0.46);
            font-size: 70px;
            margin-top: -20px;
        }
        .textUp{
            color: #409EFF;
        }
        .Selected{
            color: rgba(199, 199, 199, 0.67);
        }

    }
    .SelectedCursor{
        cursor: default;
    }

</style>
